import axios from '@axios'
import Vue from 'vue';
import {UserRoleEnum} from '@/constants/roles'
import store from '@/store/index';

export const userService = {
    login,
    loginWithToken,
    canNavigate,
    canHaveMenuItem,
    getCurrentUser,
};

function login(email, password) {
    return axios.post(`${Vue.prototype.$apiUrl}/Token/backoffice`, { email, password }, { headers: { 'Content-Type': 'application/json' } })
}

function loginWithToken(token) {
    return axios.post(`${Vue.prototype.$apiUrl}/Token/loginwithtoken`, `"${token}"`, { headers: { 'Content-Type': 'application/json' } })
}

function getCurrentUser() {
    return axios.get(`${Vue.prototype.$apiUrl}/Account/currentUser`, { headers: { 'Content-Type': 'application/json' } })
}

function canHaveMenuItem(itemName) {
    if (itemName === 'home') {
        return true;
    }

    let user = store.state.userData.userData;
    if (!user) return false;

    const isSuperAdmin = user.role === UserRoleEnum.SuperAdmin || user.role === UserRoleEnum.BackofficeUser;
    let permission = user.permission;
    permission = permission && permission.boMenuPermissions ? permission.boMenuPermissions : [];

    if (!user) {
        return false;
    }
    console.log(itemName)
    const appAdminMenu = [
        'users',
        'themes',
        'editUser',
        'editTheme'
    ];
    if (isSuperAdmin) {
        return true;
    } else if (appAdminMenu.includes(itemName) && user.role === UserRoleEnum.AppAdmin) {
        return true;
    }else{
        return permission.filter(perm => perm.permissions.match(itemName)).length > 0;
    }

    // return true;
}

function canNavigate(to) {
    return canHaveMenuItem(to.name)
}